import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';

import { AuthService } from '../auth.service';
import { SubscriptionService } from '../subscription.service';
import { CommunicationService } from '../communication.service'

import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { Message } from 'primeng/components/common/api';

import { MenuItem } from 'primeng/api';

import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  // SERVICES MENU
  public items: MenuItem[];

  // CLIENT DATA
  public name: string;

  // CLIENT USERNAME
  public username: string;

  // MESSAGES AFTER EDIT
  errorEdit: Message[] = [];
  successEdit: Message[] = [];

  // FORM FIELDS
  dataForm = new FormGroup({
    nomeForm: new FormControl(''),
    cognomeRagSocForm: new FormControl('', Validators.required),
    pivaForm: new FormControl(''),
    codFiscaleForm: new FormControl('', Validators.minLength(16)),
    indirizzoForm: new FormControl(''),
    capForm: new FormControl(''),
    cittaForm: new FormControl(''),
    provinciaForm: new FormControl(''),
    nazioneForm: new FormControl(''),
    telefonoForm: new FormControl(''),
    emailForm: new FormControl(''),
    dest_feForm: new FormControl(''),
    pec_feForm: new FormControl('')
  });

  constructor(
      private auth: AuthService,
      private subscription: SubscriptionService,
      private communication: CommunicationService,
      private router: Router
  ) { }

  ngOnInit() {
    this.communication.setMessage("FaceGate"); // set the title in the navbar of app component
    this.loadServicesMenu();
    this.getUserInfo();
    this.getSubscriptionData();
  }

  loadServicesMenu() {
    this.items = [
      {
        label: 'DATI',
        items: [
          {label: 'I miei dati', icon: 'pi pi-fw pi-file'},
          {label: 'La mia sottoscrizione', icon: 'pi pi-fw pi-dollar', routerLink: ['/payFacegate']}
        ]
      },
      {
        label: 'SERVIZI',
        items: [
          {label: 'Registro foto', icon: 'pi pi-fw pi-camera', routerLink: ['/photosFacegate']},
          {label: 'Dati riepilogativi', icon: 'pi pi-fw pi-users', routerLink: ['/reportsFacegate']},
          //{label: 'Configurazione', icon: 'pi pi-fw pi-cog', routerLink: ['/reportConfig']}
        ]
      }
    ];
  }

  getUserInfo() {
    this.auth.getUserInfo().subscribe(
      info => {
        console.log("Successful getUserInfo: info = " + JSON.stringify(info, null, 2));
        this.name = info.attributes.name;
      },
      error => {
        alert("GETUSERINFO ERROR");
        console.log("Failed getUserInfo: error = " + JSON.stringify(error, null, 2))
      }
    );
  }

  getSubscriptionData() {

    this.auth.getCurrentSession().subscribe(
      currSess => {
        console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        console.log("IdToken = " + idToken);
        let username = currSess.accessToken.payload.username;
        this.subscription.getSubscriptionData(idToken, username).subscribe(
          data => {
            console.log("Successfull getSubscriptionData: data = " + JSON.stringify(data, null, 2));
            this.username= username;

            this.dataForm.setValue({
              nomeForm: data.result.nome,
              cognomeRagSocForm: data.result.cognomeRagSoc,
              pivaForm: data.result.piva,
              codFiscaleForm: data.result.codFiscale,
              indirizzoForm: data.result.indirizzo,
              capForm: data.result.cap,
              cittaForm: data.result.citta,
              provinciaForm: data.result.provincia,
              nazioneForm: data.result.nazione,
              telefonoForm: data.result.telefono,
              dest_feForm: data.result.dest_fe,
              pec_feForm: data.result.pec_fe,
              emailForm: data.result.email
            });

          },
          error => {
            alert("GETSUBSCRIPTIONDATA ERROR");
            console.log("Failed getSubscriptionData: error = " + JSON.stringify(error, null, 2))
          }
        );
      },
      error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }
    );

  }

  onClickEditData(value: any) {


    if (value.nomeForm == '') value.nomeForm = ' ';
    if (value.cognomeRagSocForm == '' || value.cognomeRagSocForm == ' ' ) {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Cognome/Ragione Sociale è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if ((value.pivaForm=='' && value.codFiscaleForm=='') || (value.pivaForm==' ' && value.codFiscaleForm=='') || (value.pivaForm=='' && value.codFiscaleForm==' ') || (value.pivaForm==' ' && value.codFiscaleForm==' ')){
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Inserire almeno uno tra Codice Fiscale e Partita IVA', detail:'Modifica non riuscita'});
      return;
    }else{
      if (value.pivaForm == '') value.pivaForm = ' ';
      if (value.codFiscaleForm == '') value.codFiscaleForm = ' ';
    }
    if (value.indirizzoForm == '' || value.indirizzoForm == ' ') {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Indirizzo è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if (value.capForm == '' || value.capForm == ' ') {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'CAP è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if (value.cittaForm == '' || value.cittaForm == ' ') {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Città è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if (value.provinciaForm == '' || value.provinciaForm == ' ') {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Provincia è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if (value.nazioneForm == '' || value.nazioneForm == ' ') {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Nazione è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if (value.telefonoForm == '' || value.telefonoForm == ' ') {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Telefono è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if (value.emailForm == '' || value.emailForm == ' ') {
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Email è un campo obbligatorio:', detail:'Modifica non riuscita'});
      return;
    }
    if ((value.dest_feForm=='' && value.pec_feForm=='') || (value.dest_feForm==' ' && value.pec_feForm=='') || (value.dest_feForm=='' && value.pec_feForm==' ') || (value.dest_feForm==' ' && value.pec_feForm==' ') ){
      this.errorEdit = [];
      this.errorEdit.push({severity:'error', summary:'Inserire almeno uno tra Destinatario Fattura Elettronica e PEC Fattura Elettronica', detail:'Modifica non riuscita'});
      return;
    }else{
      if (value.dest_feForm == '') value.dest_feForm = ' ';
      if (value.pec_feForm == '') value.pec_feForm = ' ';
    }

    this.auth.getCurrentSession().subscribe(
      currSess => {
        // console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        // console.log("IdToken = " + idToken);
        let username = currSess.accessToken.payload.username;
        this.subscription.updateSubscriptionData(idToken, username, value.nomeForm, value.cognomeRagSocForm, value.pivaForm,
                                                  value.codFiscaleForm, value.indirizzoForm, value.capForm, value.cittaForm, value.provinciaForm, value.nazioneForm,
                                                  value.telefonoForm, value.dest_feForm, value.pec_feForm, value.emailForm).subscribe(
          data => {
            console.log("Successfull updateSubscriptionData: data = " + JSON.stringify(data, null, 2));
            this.getSubscriptionData();
            this.successEdit = [];
            this.successEdit.push({severity:'success', summary:'Operazione eseguita con successo:', detail:'Hai modificato la tua anagrafica.'});
          },
          error => {
            alert("UPDATESUBSCRIPTIONDATA ERROR");
            console.log("Failed getSubscriptionData: error = " + JSON.stringify(error, null, 2))
          }
        );
      },
      error => {
        alert("UPDATECURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }
    );

  }

}
